/**
 * Keep FY27 eligibility enrollment rows aligned with the review's grants.
 * Grant IDs come from the review, but enrollment figures must still be checked
 * against HSES; the review's other enrollment fields are not a verified HSES
 * source and must not be substituted for a missing value.
 */
export const populateFundedEnrollmentRows = (
  formData,
  properties,
  grantInfo
) => {
  const rootKey = Object.keys(properties || {}).find(
    key => properties[key]?.properties?.fundedEnrollments
  );
  if (!rootKey || !Array.isArray(grantInfo) || !grantInfo.length) {
    return formData;
  }

  const grantIds = [
    ...new Set(grantInfo.map(grant => grant?.granteeId).filter(Boolean)),
  ];
  if (!grantIds.length) return formData;

  const root = formData?.[rootKey] || {};
  const savedRows = Array.isArray(root.fundedEnrollments)
    ? root.fundedEnrollments
    : [];
  const fundedEnrollments = grantIds.map(granteeId => {
    // Prefer a complete entry when older answers have duplicate grant rows.
    const matches = savedRows.filter(row => row?.granteeId === granteeId);
    const saved =
      matches.find(
        row =>
          row.fundedEnrollment !== undefined &&
          row.fundedEnrollment !== null &&
          row.fundedEnrollment !== ''
      ) || matches[0];
    return saved || { granteeId };
  });

  return {
    ...formData,
    [rootKey]: { ...root, fundedEnrollments },
  };
};

/**
 * Review grant IDs identify the row whose HSES enrollment is being entered.
 * A changed grant selector can silently associate a saved number with the
 * wrong grant, so show these IDs as values only on the FY27 enrollment form.
 * Clone the UI schema to avoid changing other GrantsList questions.
 */
export const displayFundedEnrollmentGrantIds = (uiSchema, properties) => {
  const rootKey = Object.keys(properties || {}).find(
    key => properties[key]?.properties?.fundedEnrollments
  );
  const grantField = uiSchema?.[rootKey]?.fundedEnrollments?.items?.granteeId;
  if (!rootKey || !grantField) return uiSchema;

  return {
    ...uiSchema,
    [rootKey]: {
      ...uiSchema[rootKey],
      fundedEnrollments: {
        ...uiSchema[rootKey].fundedEnrollments,
        items: {
          ...uiSchema[rootKey].fundedEnrollments.items,
          granteeId: {
            ...grantField,
            'ui:options': { ...grantField['ui:options'], displayOnly: true },
          },
        },
      },
    },
  };
};
